import React, {useState} from 'react';
import {
    HiBarsArrowUp,
    HiBarsArrowDown,
  } from "react-icons/hi2";
import styled from 'styled-components';
import {
  HiArrowRightOnRectangle,
} from "react-icons/hi2";

import ShibaLogo from '../pictures/shibaLogo.jpeg';
import CocktailTokenLogo from '../pictures/cryptobartl_logo.png';
import { NavComponent } from '../navigationComponents/NavComponent';

const StyledButton = styled.button`

justify-content: center;
padding: 10px 20px;

  background-color: #black;
  color: white;
  border: 2px solid #9a5ecb; /* Added border color */
  border-radius: 15px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;

  &:hover {
    background-color: #9a5ecb;
    transform: scale(1.05); /* Slight zoom effect */
  }

  svg {
    margin-left: 8px; /* Space between text and icon */
    font-size: 20px;
  }
`;

function TokenFactory()
{

    //for collapsing
  
  const [openTokenFactory, setOPenTokenFactory] = useState(false);
  const [openShibConisProject, setOPenShibConisProject] = useState(false);
  const [openCocktailTokenProject, setOPenCocktailTokenProject] = useState(false);

  const toggle_TokenFactory = () => {
    setOPenTokenFactory(!openTokenFactory);
  };
  const toggle_ShibConisProject = () => {
    setOPenShibConisProject(!openShibConisProject);
  };
  const toggle_CocktailTokenProject = () => {
    setOPenCocktailTokenProject(!openCocktailTokenProject);
  };


    return (
        <main>
            <div id="divHomepage" className='homepageDesign'>
            
            <NavComponent/>
    
            
    <div id="TokenFactoryDIV" >
      <h1 className="factoryTitle"> The Token Factory </h1>

      <div style={{ borderTop: "2px solid #333 ", marginLeft: 20, marginRight: 20 }}></div>
      <div id="internalNav" className="intpageNavigation">
            <p className='ulMidP'>DefinitionPage: </p>
            <ul className='intpageNavigation'>
                <li className='intpageNavigation'> <a href="#TokenNetworks" className='intpageNavigation'>#DefinitionsPage: Token Networks</a></li>
                <li className='intpageNavigation'> <a href="#TypeOfTokens" className='intpageNavigation'>#DefinitionsPage: Type of Tokens</a></li>
                <li className='intpageNavigation'> <a href="#IdeasTokenUsage" className='intpageNavigation'>#DefinitionsPage: Ideas for Token Usage</a></li>
                <li className='intpageNavigation'> <a href="#TokenProperties" className='intpageNavigation'>#DefinitionsPage: TokenProperties</a></li>   
            </ul>
            <button onClick={toggle_TokenFactory} className="factoryTitle"> <HiBarsArrowDown/>
                    {'Press to fall down the Token Factory - DefinitionsPage'} 
            </button>
            <br/>
            <br/>
            <div style={{ borderTop: "2px solid #333 ", marginLeft: 20, marginRight: 20 }}></div>
            <p className='ulMidP'>Projects: </p>
            <ul> 
                <li className='intpageNavigation'> <a href="#ShibConis" className='intpageNavigation'>#Project0: ShibConis</a></li>
                <li className='intpageNavigation'> <a href="#CocktailToken" className='intpageNavigation'>#Project1: Cocktail Token</a></li>
            </ul>
      </div>
      <div style={{ borderTop: "2px solid #333 ", marginLeft: 20, marginRight: 20 }}></div>

      <div id="DefinitionsPage">
      
      {openTokenFactory && (
              <div className="toggle">
                  <div id="TokenNetworks" className='factoriesDesign'>
                  <h2>Token Networks</h2>
                  <p>Our services are supporting the ERC20 (Ethereum) and the BEP20 (Binance Chain) standards.</p>
                  <p>Following networks are taken into consideration by us:</p>
                    <table>
                      <thead>
                        <tr>
                          <th scope="col">Network</th>
                          <th scope="col">Property</th>
                          <th scope="col">Recommanded by us</th>
                        </tr>
                      </thead>
                      <tbody>
                            <tr>
                              <th scope="row">Ethereum</th>
                              <td>most popular, highest TotalValueLocked, highest transaction volume but quite high fees</td>
                              <td>yes</td>
                            </tr>
                            <tr>
                              <th scope="row">Tron</th>
                              <td>Large transaction volume mainly due to stable coins and low fee, but not many tokens use it</td>
                              <td>no</td>
                            </tr>
                            <tr>
                              <th scope="row">Binance Smart Chain</th>
                              <td>Low transaction fees,, sufficient network speed and very high popularity</td>
                              <td>yes</td>
                            </tr>
                            <tr>
                              <th scope="row">Arbitrum One</th>
                              <td>Ethereum Layer 2, low transaction fee, gaining popularity</td>
                              <td>yes</td>
                            </tr>
                            <tr>
                              <th scope="row">Optimism</th>
                              <td>Ethereum Layer 2, allows same as Ethereum, much less in terms of costs</td>
                              <td>yes</td>
                            </tr>
                            <tr>
                              <th scope="row">Avalance AVAX</th>
                              <td>Maximum 4500 transactions per second, low transaction fee</td>
                              <td>no</td>
                            </tr>
                            <tr>
                              <th scope="row">Polygon MATIC</th>
                              <td>Very fast transaction, low cost</td>
                              <td>no</td>
                            </tr>
                          </tbody>
                    </table>
                  <br/>
                  <br/>
                  </div>

                  <div id="TypeOfTokens" className='factoriesDesign'>
                    <h2>Type of tokens</h2>
                    <p>Memecoin: gains value only within publicity. E.g. Dogecoin, ShibaInu</p>
                    <p>Deflationary: supply decreases over time, have a high burn percentage in the smart contract. E.g. GoldenEgg on BSC: 
                      one million tokens, in which 6% fee is charged every transaction. 4% distribution to the holders, 2% is burned.
                    </p>
                    <p>Holder (Divided-paying tokens): awards received for holding the token. The mechanism encourages investors to hold in exchange
                      for receiving dividents from token transactions (for every buy and sell transaction). 
                      "Just buy tokens, keep them in your wallet,
                      don't sell them, get rewards every 60 minutes. That's it. No additional action required."
                    </p>
                    <p>Play2Earn: e.g. Axie Infinity - a gaming concept in which the game provides its players which a chance to earn cards, items and more, which can later ve converted into cryptocurrencies
                      or FIAT. Mindset to be established in such games: not the "play to earn", but to "play and earn"!
                    </p>
                  </div>

                  <br/>
                  <div id="IdeasTokenUsage" className='factoriesDesign'>
                      <h2>Ideas for token usage</h2>
                      <p>Utility tokens. Tokens with a real use are utility tokens. The token is designed to perform certain actions within the blockchain of 
                        a specific project. They can help create an internal economy. They are commonly sold in the form of fundraising at the project formation.
                        Example: Binance Coin (BNB) is mainly used to pay for trading fees and transactions on the Binance Exchange. Binance encourages to use BNB instead of 
                        stablecoins or orther crypto by offering discounts.
                        Utiliy tokens do not generate by default any return on the investment.
                      </p>
                      <p>Security token. Is a financial instrument that has value and can be traded. It represents a stake in some external company or asset.
                        They can be issued by entities such as companies or governments and serve the same purpose as their counterparts (e.g. stocks, bonds, etc).
                      </p>
                      <p>Exchange token. These are tokens created and issued by exchanges, they provide holders with certain benefits, such as
                        discounts on crypto trading. Example: BNB for Binance, CNB for Coinsbit, HT for Huobi.
                        Having exchange tokens also often entitles one to take part in free token drops of new projects on exchanges.
                      </p>
                  </div>
                  <br/>
                  <br/>

                  <div id="TokenProperties" className='factoriesDesign'>
                      <h2>Configurations which must be implemented for the tokens</h2>
                      <ul className="requestDesign">
                          <li>Token name</li>
                          <li>Symbol: unique combination of letters assigned to a token/coin/stock</li>
                          <li>Total supply: sum of circulating supply and tokens that are locked into a smart contract</li>
                      </ul>
                      <br/>

                      <h3>Optional configurations of the tokens:</h3>
                      <ul className="requestDesign">
                          <li>Maximum supply (optional): the upper limit on the number of tokens that will exist</li>
                          <li>Max Wallet (optional): limit the maximum numbers of tokens a single address can hold</li>
                          <li>Max Tx (optional): limit the maximum number of tokens that can flow into a single transaction</li>
                          <li>Air Drops (optional): pay holders a portion of the fees collected, rewarding them for holding the token in their wallet</li>
                          <li>Fees (optional): </li>
                          <ul>
                              <li> Buy/Sell fee: for buying or selling the token</li>
                              <li> Early sell fee: penalty for early selling</li>
                              <li> Reflection fee: the re-distribution fee</li>
                              <li> Dev fee: for development</li>
                              <li> Burn fee: a fee that is burned</li>
                              <li> Marketing fee: for marketing purposes</li>
                              <li>Charity Fee: transfer funds from each fee, to a designated address</li>
                              <li> Liquidity fee: a fee for which funds go into a liquidity pool</li>
                          </ul>
                          <li>Burning (optional): like burning cash or artwork, virtually. Can increase the price.</li>
                          <li>Mintability (optional): the contract creator can mint more tokens, increasing the total supply</li>
                          <li>Blacklist (optional): prevent specific addresses from participating in certain token-related activities</li>
                          <li>Whitelist (optional): receive exclusive or priority access - e.g. for pre-sales</li>
                      </ul>
                  </div>

                  <br/>
                  <br/>
                  <p style={{fontStyle:'italic', fontSize:12}}>Main source of information:   Boron Piotr. Your own token. 2023 </p>
                  <br/>
                  <br/>
                  <button onClick={toggle_TokenFactory} className="factoryTitle"> <HiBarsArrowUp/>
                    {'Press hide the Token Factory - DefinitionsPage'} 
                  </button>

              </div>
      )}
      </div>
      
      <br/>
      <br/>
      <div style={{
        textAlign: 'center',
        margin: 'auto',
        padding: '15px',
        border: '1px solid #ccc', // Light gray border
        borderRadius: '10px', // Rounded corners
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)', // Subtle shadow
        backgroundColor: 'transparent', // Transparent background
        width: '70%'

      }}>
        <h1> Do you want to be the owner of your own token? </h1>
        <p></p>
        <br/>
        <p>Let us know what you're building. We'll help you choose the right package and deliver a professional Web3 asset 
          <br/>— ready to deploy or distribute.</p>
        <br />
        <a href="/Shop" style={{ textDecoration: 'none' }}>
          <StyledButton>
          Select your Token Package
            <HiArrowRightOnRectangle />
          </StyledButton>
        </a> 
      </div>

      <br/>
      <br/>
      <h1>Get inspired by our Token projects!</h1>
      <br/>

      <div id="ShibConis" className="factoriesDesign">
        <h1 style={{ color: "#b86fec", textAlign: "center", fontSize: "2.2rem", marginBottom: 0 }}>PROJECT 0: ShibConis - The MemeCoin Token</h1>
        <img src={ShibaLogo} alt="ShibConis image" style={{ display: "block", margin: "24px auto 8px", width: 120, height: 120, borderRadius: "50%", objectFit: "cover", boxShadow: "0 2px 12px rgba(186,111,236,0.12)" }} />
        <div style={{ textAlign: "center", margin: "8px 0 16px" }}>
          <a href="https://basescan.org/address/0x038E4Cb215731B927Af31c320360DC37bd14b2d7" target="_blank" rel="noopener noreferrer" style={{ color: "#b86fec", fontWeight: 500 }}>
            View on Base blockchain
          </a>
        </div>
        <div style={{ textAlign: "center", marginBottom: 16 }}>
          <button onClick={toggle_ShibConisProject} className="factoryTitle" style={{ background: "#b86fec", color: "#fff", border: "none", borderRadius: 12, padding: "10px 24px", fontWeight: 600, fontSize: 16, cursor: "pointer", boxShadow: "0 2px 8px rgba(186,111,236,0.10)" }}>
            {openShibConisProject ? 'Hide ShibConis Project' : 'Show ShibConis Project'}
          </button>
        </div>
        {openShibConisProject && (
        <div className="projectListDesign" style={{
          background: "rgba(44,44,44,0.97)",
          borderRadius: "16px",
          boxShadow: "0 4px 16px rgba(0,0,0,0.2)",
          padding: "32px 16px",
          margin: "32px auto",
          maxWidth: 800,
          color: "#fff"
        }}>
          <img src={ShibaLogo} alt="ShibConis Logo" style={{
            display: "block", margin: "0 auto 16px", width: 120, height: 120, borderRadius: "50%", objectFit: "cover"
          }} />
          <h2 style={{ color: "#b86fec", fontSize: "2.2rem", textAlign: "center" }}>
            ShibConis (SHB)
          </h2>
          <p style={{ fontStyle: "italic", textAlign: "center", color: "#b86fec" }}>
            A Token Inspired by Our Real Shiba Inu Family
          </p>
          <p style={{ textAlign: "center", margin: "16px 0" }}>
            ShibConis (SHB) is a purpose-driven Ethereum-based token, inspired by the loyalty, intelligence, and spirit of our own real-life Shiba Inu. More than a meme — it's a mission.
          </p>
          <br/>
          <ul style={{
            listStyle: "none", padding: 0, margin: "24px 0", display: "flex", flexWrap: "wrap", justifyContent: "center", gap: "16px"
          }}>
            <li style={{display: "flex", alignItems: "center", background: "#222", borderRadius: "8px", padding: "10px 18px", boxShadow: "0 2px 8px rgba(186,111,236,0.08)", fontWeight: 500}}>
              <span style={{fontSize: "1.3em", marginRight: 8}}>🔒</span>Fast, secure peer-to-peer transfers
            </li>
            <li style={{display: "flex", alignItems: "center", background: "#222", borderRadius: "8px", padding: "10px 18px", boxShadow: "0 2px 8px rgba(186,111,236,0.08)", fontWeight: 500}}>
              <span style={{fontSize: "1.3em", marginRight: 8}}>🔥</span>Burnable supply
            </li>
            <li style={{display: "flex", alignItems: "center", background: "#222", borderRadius: "8px", padding: "10px 18px", boxShadow: "0 2px 8px rgba(186,111,236,0.08)", fontWeight: 500}}>
              <span style={{fontSize: "1.3em", marginRight: 8}}>🎗️</span>Built-in charity fee
            </li>
            <li style={{display: "flex", alignItems: "center", background: "#222", borderRadius: "8px", padding: "10px 18px", boxShadow: "0 2px 8px rgba(186,111,236,0.08)", fontWeight: 500}}>
              <span style={{fontSize: "1.3em", marginRight: 8}}>👥</span>Community-driven ownership
            </li>
            <li style={{display: "flex", alignItems: "center", background: "#222", borderRadius: "8px", padding: "10px 18px", boxShadow: "0 2px 8px rgba(186,111,236,0.08)", fontWeight: 500}}>
              <span style={{fontSize: "1.3em", marginRight: 8}}>💱</span>ETH-based buying
            </li>
          </ul>
          <br/>
          <p style={{ textAlign: "center", color: "#b86fec", fontWeight: "bold", cursor: "pointer", textDecoration: "underline" }}
             onClick={() => window.location.href = '/ProjectShibConis'}
          >
            ➡️ Get SHB. Powered by paws. Backed by purpose.
          </p>
          <div style={{ textAlign: "center", margin: "24px 0" }}>
            <a href="https://basescan.org/address/0x038E4Cb215731B927Af31c320360DC37bd14b2d7" target="_blank" rel="noopener noreferrer">
              <StyledButton>View on Base Blockchain</StyledButton>
            </a>
          </div>
          <br/>
          <br/>
          <br/>
          <h4>### Who Are the Founders of ShibConis?</h4>
          <p style={{ textAlign: "left", margin: "16px 0" }}>
          ShibConis is the brainchild of CryptoBartl, who has extensive experience in programming and management. As the proud owners of two Shiba Inus, who on their own brough more Shiba Inus into the world, this token is created to live up to their grace. 
             Rewards will be given in the form of the ShibConis. </p>

          <p style={{ textAlign: "left", margin: "16px 0" }}>
          The ShibConis will not die as a Hype only. As owner we have the possibility to mint further coins, to assure it will not disappear from the market. 
              We can also increase the usage scenarios of the token, for different upcoming projects – as it will be easily accessible and due to our original physical location, a great advantage for various investors and start-ups can be provided.</p>
                  
          </div>
          )}
        </div>
              

      <br/>
        <div id="CocktailToken" className="factoriesDesign">
            <h1 style={{ color: "#b86fec", textAlign: "center", fontSize: "2.2rem", marginBottom: 0 }}>PROJECT 1: Cocktail Token</h1>
            <img src={CocktailTokenLogo} alt="Cocktail token image" style={{ display: "block", margin: "24px auto 8px", width: 120, height: 120, borderRadius: "50%", objectFit: "cover", boxShadow: "0 2px 12px rgba(186,111,236,0.12)" }} />
            <div style={{ textAlign: "center", margin: "8px 0 16px" }}>
              <a href="https://bscscan.com/address/0xA825094bD6053FeF815EbE8ED7Ac9d5539cE67B1#code" target="_blank" rel="noopener noreferrer" style={{ color: "#b86fec", fontWeight: 500 }}>
                View on BSC (Binance Smart Chain)
              </a>
            </div>
            <div style={{ textAlign: "center", marginBottom: 16 }}>
              <button onClick={toggle_CocktailTokenProject} className="factoryTitle" style={{ background: "#b86fec", color: "#fff", border: "none", borderRadius: 12, padding: "10px 24px", fontWeight: 600, fontSize: 16, cursor: "pointer", boxShadow: "0 2px 8px rgba(186,111,236,0.10)" }}>
                {openCocktailTokenProject ? 'Hide Cocktail Token Project' : 'Show Cocktail Token Project'}
              </button>
            </div>
            {openCocktailTokenProject && (
              <div className="projectListDesign" style={{
                background: "rgba(44,44,44,0.97)",
                borderRadius: "16px",
                boxShadow: "0 4px 16px rgba(0,0,0,0.2)",
                padding: "32px 16px",
                margin: "32px auto",
                maxWidth: 800,
                color: "#fff"
              }}>
                <h2 style={{ color: "#b86fec", fontSize: "2rem", textAlign: "center" }}>CocktailToken (CCK)</h2>
                <p style={{ fontStyle: "italic", textAlign: "center", color: "#b86fec" }}>
                  A Token for the Nightlife & Crypto Enthusiasts
                </p>
                <p style={{ textAlign: "center", margin: "16px 0" }}>
                  CocktailToken is a crypto token / smart contract created on the Binance Smart Chain network. It aims to facilitate increased liquidity and provide cryptocurrency traders and general users with an asset, encouraging the youth to consider investing in cryptocurrencies.
                </p>
                <ul style={{
                  listStyle: "none", padding: 0, margin: "24px 0", display: "flex", flexWrap: "wrap", justifyContent: "center", gap: "16px"
                }}>
                  <li style={{display: "flex", alignItems: "center", background: "#222", borderRadius: "8px", padding: "10px 18px", boxShadow: "0 2px 8px rgba(186,111,236,0.08)", fontWeight: 500}}>
                    <span style={{fontSize: "1.3em", marginRight: 8}}>🍸</span>Nightlife & reward utility
                  </li>
                  <li style={{display: "flex", alignItems: "center", background: "#222", borderRadius: "8px", padding: "10px 18px", boxShadow: "0 2px 8px rgba(186,111,236,0.08)", fontWeight: 500}}>
                    <span style={{fontSize: "1.3em", marginRight: 8}}>💸</span>Exchange token for discounts
                  </li>
                  <li style={{display: "flex", alignItems: "center", background: "#222", borderRadius: "8px", padding: "10px 18px", boxShadow: "0 2px 8px rgba(186,111,236,0.08)", fontWeight: 500}}>
                    <span style={{fontSize: "1.3em", marginRight: 8}}>🔒</span>MaxWallet & MaxTx protection
                  </li>
                  <li style={{display: "flex", alignItems: "center", background: "#222", borderRadius: "8px", padding: "10px 18px", boxShadow: "0 2px 8px rgba(186,111,236,0.08)", fontWeight: 500}}>
                    <span style={{fontSize: "1.3em", marginRight: 8}}>🛡️</span>Blacklist for security
                  </li>
                  <li style={{display: "flex", alignItems: "center", background: "#222", borderRadius: "8px", padding: "10px 18px", boxShadow: "0 2px 8px rgba(186,111,236,0.08)", fontWeight: 500}}>
                    <span style={{fontSize: "1.3em", marginRight: 8}}>🔥</span>Uncapped supply, community-driven
                  </li>
                </ul>
                <p style={{ textAlign: "center", color: "#b86fec", fontWeight: "bold" }}>
                  ➡️ Get CCK. Mix your crypto with real-life fun!
                </p>
                <div style={{ textAlign: "center", margin: "24px 0" }}>
                  <a href="https://bscscan.com/address/0xA825094bD6053FeF815EbE8ED7Ac9d5539cE67B1#code" target="_blank" rel="noopener noreferrer">
                    <StyledButton>View on BSC</StyledButton>
                  </a>
                </div>
                <h4 style={{ color: "#b86fec", marginTop: 32 }}>Who Are the Founders of CocktailToken?</h4>
                <p style={{ textAlign: "left", margin: "16px 0" }}>
                  CocktailToken is a token launched by CryptoBartl, founded by Elena Bartl and family. With experience from various top industries and a strong network, the project is set for success.
                </p>
                <h4 style={{ color: "#b86fec", marginTop: 24 }}>What Makes CocktailToken Unique?</h4>
                <p style={{ textAlign: "left", margin: "16px 0" }}>
                  CocktailToken aims to increase interest in crypto investments, especially among the youth and nightlife scene. Small investments, like buying a token with your cocktail, make crypto accessible and fun. The token is also integrated into the Crypto Cocktail Party app for rewards and discounts.
                </p>
                <h4 style={{ color: "#b86fec", marginTop: 24 }}>How Many CCK Coins Are There?</h4>
                <p style={{ textAlign: "left", margin: "16px 0" }}>
                  There are one billion CCK in circulation as of April 2024. The supply is uncapped and can expand with demand. Major holders are involved in decisions about minting and burning.
                </p>
                <h4 style={{ color: "#b86fec", marginTop: 24 }}>How Is CocktailToken Secured?</h4>
                <p style={{ textAlign: "left", margin: "16px 0" }}>
                  CocktailToken follows ERC20/BEP20 standards and includes features like MaxWallet, MaxTx, and a blacklist to protect against fraud and manipulation.
                </p>
              </div>
            )}
        </div>
        </div>

        <div style={{ borderTop: "2px solid #fff ", marginLeft: 20, marginRight: 20 }}></div>
        <p style={{textAlign: "center"}}>Copyright © 2025 CryptoBartl</p>
            
      </div>
      </main>
    )

}

export default TokenFactory;